import LocalStorageService from "../services/storage/LocalStorageService";
import centralApiAxios from "../axios/centralApiAxios";

export const setPageTitle = (pageTitle) => {
    LocalStorageService.getService().setActivityInfo(pageTitle);
}

export const getActivityHeadersUpdated = (payload) => {
    let configUpdated = { ...centralApiAxios.defaults };
    if (payload.activityInfo) {
        configUpdated.headers = { ...configUpdated.headers, ...payload.activityInfo };
    }
    return configUpdated;
}

export const getCreatedByContext = (contact) => {
    if (contact) {
        return {
            CreatedByFirstName: contact.firstName,
            CreatedByMiddleName: contact.middleName,
            CreatedByLastName: contact.lastName,
            CreatedByInitials: contact.firstName ? contact.firstName.substring(0, 1) : null,
            CreatedByUrl: `/app/contact-overview/${contact.contactId}`
        }
    } else {
        return {
            CreatedByFirstName: "Aida"
        }
    }
}

export const createUIActivity = (activityDetails, processCode, activityContext, targetRecordType, targetRecordId, verbType, activityGuid) => {
    const createActivity = async (activityObj) => {
        try {
            const responseObject = await centralApiAxios.post("activities", activityObj);
            //console.log(responseObject.data);
        } catch (err) {
            console.log("Failed to create activity: ${activityDetails}. Error: ${err}");
        }
    }
    const activityObj = {
        ActivityGuid: activityGuid ? activityGuid : "00000000-0000-0000-0000-000000000000",
        Description: activityDetails,
        ProcessCode: processCode,
        ActivityContext: activityContext,
        Target_RecordType: targetRecordType,
        TargetRecordId: targetRecordId,
        VerbType: verbType,
        UrlDomain: window.location.host,
        UrlPath: window.location.pathname ? window.location.pathname : "",
        UrlQueryString: window.location.search ? window.location.search : "",
        ActivityDateTime: new Date(),
        IsUiActivity: true
    }
    createActivity(activityObj);
}